import React from "react";
import AppContainer from "../../../components/AppContainer";
import GlobalButton from "../../../components/CustomButton";
import ExportButton from "../../../components/ExportButton";
import CustomSelect from "./../../../components/customSelect/index";
import { MenuItem, Stack } from "@mui/material";
import { allIcons } from "../../../assets";
import DynamicTable from "../../../components/DynamicTable";
import TableData from "../../../dumyData/education/EducationNewAdmissions.json";

const IDCards = ["ID Cards", "Report Card"];
const allClasses = ["Class 1", "Class 2", "Class 3", "Class 4"];
const Sections = ["Section A", "Section B", "Section C"];
const Status = ["Issue", "Not Delivered"];

const headerData = [
  "Roll Number",
  "Student Detail",
  "ID Card Status",
  "Action",
];

const displayRows = [
  "_id",
  "ed_student_detail",
  "ed_id_card_status",
  "actions",
];

const AllStudentsReports = () => {
  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <CustomSelect
          formStyleProps={{ width: "25%" }}
          icon={<img src={allIcons.reportCardBlackIcon} width={16} />}
          placeholder={"ID Cards"}
        >
          {IDCards.map((val, index) => {
            return (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            );
          })}
        </CustomSelect>
        <ExportButton handleClick={() => console.log("helllo")} />
        <GlobalButton
          btnText={"Create New"}
          //   handleClickBtn={() =>
          //     openTimeTableDialog.current.openDialog({ data: null, type: "add" })
          //   }
          styleProps={{ height: 40, width: "auto" }}
        />
      </Stack>
    );
  };

  const renderSearchers = () => {
    return (
      <Stack flex={1} direction={"row"} alignItems={"center"} gap={1}>
        <CustomSelect
          formStyleProps={{ width: "20%" }}
          icon={<img src={allIcons.classBlackIcon} width={16} />}
          placeholder={"By Class"}
        >
          {allClasses.map((val, index) => {
            return (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            );
          })}
        </CustomSelect>
        <CustomSelect
          formStyleProps={{ width: "20%" }}
          icon={<img src={allIcons.timerBlackIcon} width={16} />}
          placeholder={"Sections"}
        >
          {Sections.map((val, index) => {
            return (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            );
          })}
        </CustomSelect>
        <CustomSelect
          formStyleProps={{ width: "20%" }}
          icon={<img src={allIcons.timerBlackIcon} width={16} />}
          placeholder={"Status"}
        >
          {Status.map((val, index) => {
            return (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            );
          })}
        </CustomSelect>
      </Stack>
    );
  };

  return (
    <AppContainer
      primaryHeading={"All Students Reports"}
      secondaryHeading={"Print out students reports cards"}
      headProps={renderRightPart()}
      showSerach={true}
      searchMenuProps={renderSearchers()}
    >
      <DynamicTable
        tableHeader={headerData}
        displayRows={displayRows}
        tableData={TableData}
        showPrintButton={true}
      />
    </AppContainer>
  );
};

export default AllStudentsReports;
